@if (appNameReady) {
  <nav class="navbar navbar-expand-sm navbar-light" id="navbar">
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <a
              class="nav-link"
              [routerLink]="routerLinkHome"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">
              {{ appName }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="routerLinkAnalyze" routerLinkActive="active">Analyze</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="routerLinkSessions" routerLinkActive="active">Sessions</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="routerLinkManual" routerLinkActive="active">Manual</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="routerLinkAccess" routerLinkActive="active">Getting Access</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="routerLinkContact" routerLinkActive="active">Contact</a>
          </li>
          @if (isAdmin()) {
            <li class="nav-item">
              <a class="nav-link" [routerLink]="routerLinkAdmin" routerLinkActive="active">Admin</a>
            </li>
          }
          <li class="nav-item">
            <a class="nav-link cursor-pointer" [routerLink]="" (click)="openNews()">
              News
              <!-- <i *ngIf="unreadNews" class="fas fa-bell" aria-hidden="true"></i> -->
              @if (isLoggedIn() && unreadNewsCount > 0) {
                <span class="badge bg-primary rounded-pill">
                  {{ unreadNewsCount }}
                </span>
              }
            </a>
          </li>
        </ul>

        <ul class="navbar-nav">
          @if (isLoggedIn()) {
            <li class="nav-item" ngbDropdown>
              <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdown2" role="button">
                <i class="fas fa-user" aria-hidden="true"></i>
                {{ getAccountName() }}
              </a>
              <div ngbDropdownMenu aria-labelledby="navbarDropdown2" class="dropdown-menu dropdown-menu-end">
                <button ngbDropdownItem (click)="openAccount()">
                  <i class="fas fa-user fa-fw lighter"></i>
                  Account
                </button>
                <button ngbDropdownItem (click)="openSettings()">
                  <i class="fas fa-cog fa-fw lighter"></i>
                  Settings
                </button>
                <button ngbDropdownItem (click)="openKeyboardShortcuts()">
                  <i class="fas fa-keyboard fa-fw lighter"></i>
                  Keyboard shortcuts
                </button>
                <div class="dropdown-divider"></div>
                <a ngbDropdownItem [routerLink]="routerLinkHome" (click)="logout()">
                  <i class="fas fa-sign-out-alt fa-fw lighter"></i>
                  Logout
                </a>
              </div>
            </li>
          }

          <li class="nav-item">
            @if (!isLoggedIn()) {
              <a [routerLink]="routerLinkLogin" class="nav-link" routerLinkActive="active">Log In</a>
            }
          </li>
        </ul>
      </div>
    </div>
  </nav>
}
